/** Site platform Admin Dashboard roles (Customer.UserRole). */
export function isSiteAdminRole(userRole: string | null | undefined): boolean {
  const role = String(userRole || "")
    .trim()
    .toLowerCase();
  return role === "admin" || role === "super admin";
}

export function isSiteAdminUser(user: any): boolean {
  if (!user) return false;
  return isSiteAdminRole(user.userRole ?? user.UserRole);
}
